import React, { useRef, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import {Formik, Form, Field, ErrorMessage} from "formik";
// import * as Yup from "yup";
import Icon from "@mdi/react";
import { mdiEmail, mdiPhoneInTalk, mdiMapMarker } from "@mdi/js";
// import axios from "axios";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";
// import {RotatingLines} from "react-loader-spinner";

import PageHeader from "./common/PageHeader";
import { Link } from "react-router-dom";
// import {ErrorMessage} from "formik";
// import div from "react-reveal";

const ContactUs = () => {
  const form = useRef();

  // console.log(form);

  // const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    company_name: "",
    phone: "",
    message: "",
  });

  const [fieldErrors, setFieldErrors] = useState({
    first_name: "",
    last_name: "",
    email: "",
    company_name: "",
    phone: "",
    message: "",
  });

  const handleFieldChange = (e) => {
    let vals = { ...formData };
    vals[e.target.name] = e.target.value;
    setFormData({ ...vals });
  };

  let infoBarArr = [
    {
      title: "Address",
      icon: <Icon path={mdiMapMarker} size={2} />,
      para: (
        <>
          Truzak Technology Inc. <br />
          {/* 180 Northfield Drive West, Suite 4, <br /> */}
          Ontario, Canada
        </>
      ),
    },
    {
      title: "Phone",
      icon: <Icon path={mdiPhoneInTalk} size={2} />,
      para: (
        <>
          +1 (647) 860-2211 <br /> (9:00am - 5:00pm Eastern Time) <br /> US/Canada
        </>
      ),
    },
    {
      title: "Email",
      icon: <Icon path={mdiEmail} size={2} />,
      para: "info@condozak.ca",
    },
  ];

  // React.useEffect(()=>{
  //   console.log(form.current);
  // },[])

  // const handleSubmit = user_mail_data => {
  //   console.log(user_mail_data);

  //   axios
  //     .post("http://localhost:4000/api/auth/sendmail", {
  //       email: user_mail_data.email,
  //       message: user_mail_data.message,
  //       firstname: user_mail_data.first_name,
  //       lastname: user_mail_data.last_name,
  //       companyname: user_mail_data.company_name,
  //       phone: user_mail_data.phone
  //     })
  //     .then(res => {
  //       console.log(res.data);
  //       toast.success("Email Sent.", {theme: "colored"});
  //       setTimeout(() => {
  //         window.location.reload();
  //       }, 1000);
  //     })
  //     .catch(err => {
  //       console.log(err);
  //       toast.error("Something went wrong!.", {theme: "colored"});
  //     });
  // };

  const sendEmail = (e) => {
    // console.log(form.current);

    e.preventDefault();
    // setLoader(true);

    let errors = {};
    let vals = { ...formData };
    if (!vals.first_name) errors.first_name = "First Name is required!";
    if (!vals.last_name) errors.last_name = "Last Name is required!";
    if (!vals.email) errors.email = "Email is required!";
    if (!vals.company_name) errors.company_name = "Company Name is required!";
    if (!vals.phone) errors.phone = "phone is required!";
    setFieldErrors({ ...errors });

    if (Object.keys(errors).length > 0) {
      // console.log(errors);
      // setLoader(false);
      toast.error("Please correct above errors!", { theme: "colored" });
      return;
    }

    // console.log(form);

    emailjs
      .sendForm(
        "service_xpqo9vl",
        "template_vdwpu7h",
        form.current,
        "Y8ATuGO2CeFmtgEeA"
      )
      .then(
        (result) => {
          console.log(result);
          // setLoader(false);
          toast.success("Message Sent.", { theme: "colored" });
          setFormData({
            first_name: "",
            last_name: "",
            email: "",
            company_name: "",
            phone: "",
            message: "",
          });
          setFieldErrors({
            first_name: "",
            last_name: "",
            email: "",
            company_name: "",
            phone: "",
            message: "",
          });
        },
        (error) => {
          console.log(error);
          toast.error("Something went wrong!", { theme: "colored" });
        }
      );
  };

  return (
    <div style={{ marginTop: "80px" }}>
      <div className="container">
        <PageHeader
          preTitle="We are here to help"
          title="Contact us"
          description="Whether you have a question, concern, or feedback, please feel free to contact us through any of the following channels:"
          className="mb-3"
          titleTag="h2"
        >
          {/* <Link className="btn btn-sm btn-link ps-0" to="/contact-us">
            Have questions? Chat with us
          </Link> */}
        </PageHeader>
      </div>

      <Container className="my-5">
        <Row>
          {infoBarArr.map((v, i) => (
            <Col key={i} md={4} className="text-center">
              <div className="mb-3">{v.icon}</div>
              <h4>{v.title}</h4>
              <p>{v.para}</p>
            </Col>
          ))}
        </Row>
      </Container>

      <div className="bg-white">
        <Container className="p-5">
          <div>
            <h4 className="text-center mb-3 mt-3 ">Lets get in touch.</h4>
          </div>
          <br />

          <Row>
            <Col md={6} className="text-center">
              <div>
                <div
                  style={{ width: "100%" }}
                  className="py-3 pb-3 scrollbar overflow-scroll"
                >
                  {/* <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2283.7344940143275!2d-80.54980622474086!3d43.49737507110987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882bf17ae34cfce3%3A0xd6a9c62b858ce5a!2sTruzak%20Technology%20Inc.!5e1!3m2!1sen!2s!4v1723463418665!5m2!1sen!2s"
                    width="500"
                    height="550"
                    title="condozak site"
                    style={{ border: "0", borderRadius: "5px" }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe> */}
                  <iframe
                    className="contact-map"
                    src="https://maps.google.com/maps?q=43.546484,-79.718391+(Truzak%20Technology%20Inc)&hl=en&z=15&output=embed"
                    //aria-hidden="true"
                    width="500"
                    height="550"
                    title="condozak site"
                    style={{ border: "0", borderRadius: "5px" }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </Col>

            <Col md={6} className="p-3">
              <div right>
                <form ref={form} onSubmit={sendEmail}>
                  {[
                    { name: "First Name", key: "first_name" },
                    { name: "Last Name", key: "last_name" },
                    { name: "Email Address", key: "email" },
                    { name: "Company Name", key: "company_name" },
                    { name: "Phone #", key: "phone" },
                    { name: "Message", key: "message" },
                  ].map((v, i) => (
                    <Form.Group key={i + 3214} className="mb-3">
                      <Form.Label htmlFor={v.key}>{v.name}</Form.Label>
                      <Form.Control
                        name={v.key}
                        onChange={handleFieldChange}
                        value={formData[v.key]}
                        as={v.key === "message" ? "textarea" : "input"}
                        rows={3}
                      />
                      <div>
                        <p className="text-danger fs--1 ">
                          {fieldErrors[v.key]}
                        </p>
                      </div>
                    </Form.Group>
                  ))}

                  <div className="text-end">
                    <Button variant="primary" type="submit">
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <br />
    </div>
  );
};

export default ContactUs;
